import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL?.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

export const QuickCategories = ({ language = 'en' }) => {
  const [categories, setCategories] = useState([]);
  
  useEffect(() => {
    axios.get(`${API}/blog/categories`).then(res => {
      const cats = res.data?.value || res.data || [];
      setCategories(cats);
    }).catch(console.error);
  }, []);

  if (!categories || categories.length === 0) return null;

  return (
    <div className="w-full bg-white shadow-sm border-b overflow-x-auto whitespace-nowrap py-3 px-4 mb-6 scrollbar-hide">
      <div className="flex space-x-3 items-center max-w-4xl mx-auto">
        <span className="text-gray-500 font-medium text-sm mr-2">{language === 'ta' ? 'பிரிவுகள்:' : 'Topics:'}</span>
        {categories.map(cat => (
          <Link 
            key={cat.id || cat.slug}
            to={`/blog?category=${cat.slug}`}
            className="inline-block px-4 py-1.5 bg-green-50 hover:bg-green-100 text-green-800 rounded-full text-sm font-medium transition-colors border border-green-200"
          >
            {language === 'ta' && cat.name_ta ? cat.name_ta : cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export const ReadNext = ({ currentSlug, type = 'post', language = 'en' }) => {
  const [items, setItems] = useState([]);
  
  useEffect(() => {
    const endpoint = type === 'page' ? '/blog/pages' : '/blog/posts';
    axios.get(`${API}${endpoint}`).then(res => {
      let data = res.data?.value || res.data || [];
      // Filter out current item and pick 3-4 random ones
      data = data.filter(item => item.slug !== currentSlug);
      // Shuffle array
      const shuffled = [...data].sort(() => 0.5 - Math.random());
      setItems(shuffled.slice(0, 4));
    }).catch(console.error);
  }, [currentSlug, type]);

  if (!items || items.length === 0) return null;

  return (
    <div className="mt-12 mb-8 pt-8 border-t border-gray-200">
      <h3 className="text-2xl font-bold text-gray-800 mb-6 px-2">
        {language === 'ta' ? 'அடுத்து படிக்க...' : 'Read Next...'}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map(item => (
          <Link 
            key={item.id || item.slug}
            to={type === 'page' ? `/page/${item.slug}` : `/blog/post/${item.slug}`}
            className="block p-4 rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md hover:border-orange-200 transition-all group whitespace-normal"
          >
            <h4 className="font-bold text-lg text-gray-900 group-hover:text-orange-600 mb-2 line-clamp-2">
              {language === 'ta' && item.title_ta ? item.title_ta : item.title}
            </h4>
            {item.published_at && (
              <p className="text-sm text-gray-500">
                {new Date(item.published_at).toLocaleDateString(language === 'ta' ? 'ta-IN' : 'en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
              </p>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};
